module.exports = __webpack_public_path__ + "img/logo.1290865f.png";